export default __webpack_public_path__ + "static/media/img4.4339ca3a.PNG";